@if (showAdaInteractionMessage) {
    <div>
        @if (isCountryUK) {
            <show-message [type]="messageType.INFO">
                <div info>
                    <p>{{ 'PARTY.CASHIER.web.deposit.ada.interaction.uk.msg' | translate }}</p>
                    <p class="mt-2">{{ 'PARTY.CASHIER.web.deposit.ada.interaction.uk.msg1' | translate }}</p>
                    <p
                        class="mt-2"
                        [vnDynamicHtml]="
                            'PARTY.CASHIER.web.deposit.ada.interaction.gambling.uk.msg' | translate: { gamblingControl: gamblingControlURL }
                        "></p>
                    <p class="mt-2">{{ 'PARTY.CASHIER.web.deposit.ada.interaction.uk.msg2' | translate }}</p>
                    <span>
                        <b class="ada-msg mt-2">
                            <a (click)="unblockForm()"> {{ 'PARTY.CASHIER.web.deposit.ada.interaction.cancel' | translate }} </a>
                            <a (click)="submitAdaDeposit()"> {{ 'PARTY.CASHIER.web.deposit.ada.interaction.continue' | translate }} </a>
                        </b>
                    </span>
                </div>
            </show-message>
        } @else {
            <show-message [type]="messageType.INFO">
                <div info>
                    <p>{{ 'PARTY.CASHIER.web.ada.interaction.msg1' | translate }}</p>
                    <p>{{ 'PARTY.CASHIER.web.ada.interaction.msg2' | translate }}</p>
                    <p>{{ 'PARTY.CASHIER.web.ada.interaction.msg3' | translate }}</p>
                    <span>
                        <b class="ada-msg mt-2">
                            <a (click)="submitAdaDeposit()" id="submitAdaDeposit"> {{ 'PARTY.CASHIER.web.continue' | translate }} </a>
                            <a (click)="unblockForm()" id="unblockForm"> {{ 'PARTY.CASHIER.web.ada.interaction.adjust.amount' | translate }} </a></b
                        >
                    </span>
                </div>
            </show-message>
        }
    </div>
}
